export const LOCAL_STORAGE_USER = 'loginDetail';